import {
  createCharacter,
  getCharacter,
  updateCharacter,
  deleteCharacter,

  createUnits,
  getUnits,
  updateUnits,
  deleteUnits,
} from '@/api/reference'

export default {
  CREATE_CHARACTER(_, data) {
    return createCharacter(data)
  },

  FETCH_CHARACTER({ commit }, params) {
    return getCharacter(params)
      .then(res => {
        commit('SET_CHARACTER', res.data)
      })
  },

  DELETE_CHARACTER(_, id) {
    return deleteCharacter(id)
  },

  UPDATE_CHARACTER(_, data) {
    return updateCharacter(data)
  },

  // UNITS
  CREATE_UNITS(_, data) {
    return createUnits(data)
  },

  FETCH_UNITS({ commit }, params) {
    return getUnits(params)
      .then(res => {
        commit('SET_UNITS', res.data)
      })
  },

  UPDATE_UNITS(_, data) {
    return updateUnits(data)
  },

  DELETE_UNITS(_, id) {
    return deleteUnits(id)
  },
}
